function setBlogItemBg(elClass) {
    let desktopBg = $(`.${elClass}`).attr("data-desktop-style")
    let mobBg = $(`.${elClass}`).attr("data-mob-style")
    let style

    let innerWidth = window.innerWidth


    if(innerWidth > 576){
        style = desktopBg
    } else{
        style = mobBg
    }

    $(`.${elClass}`).css("background-image",style)
}


setBlogItemBg("blog-item__wrap")
setBlogItemBg("course2__bg")

$(window).resize(function () {
    setBlogItemBg("blog-item__wrap")
    setBlogItemBg("course2__bg")
})
